export default __webpack_public_path__ + "assets/523350d33e773b7bd0bcdf242a4d9856.jpg";